<div class="mount-pallet-list">
  <div class="mount-pallet-list__wrapper mount-pallet-list__item mount-pallet-list__item--empty">
    {{ 'MOUNTING.CONSUMPTION_LIST_EMPTY' | translate }}
  </div>
</div>
